import React from "react";
import { GET_LIST, Title, Link } from "react-admin";
import { Card, CardContent } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import { API_ROOT } from "../api-config";
import moment from "moment";
import styled from "styled-components";
import { Grid, SvgIcon } from "@material-ui/core";
import InfoPopOver from "./infoPopOver";
import {
  prop,
  path,
  filter,
  descend,
  sum,
  map,
  when,
  complement,
  isNil,
  both,
  propEq,
  find,
  last,
  identity,
  assoc,
  keys,
  sortBy,
  propSatisfies,
  uniqBy,
  pathEq,
  length,
  groupBy,
  mapObjIndexed,
  values,
  startsWith,
  sortWith,
  ascend
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import Edit from "@material-ui/icons/Edit";
import DonutSmall from "@material-ui/icons/DonutSmall";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import QuickRetireButton from "./quickRetireButton";
import { getPermissionRole } from "../util";
import ElasticGrid from "./elasticGrid";

const StyledDonutSmallR = styled(DonutSmall)({
  color: "red !important",
  border: "1px solid black"
});

const StyledDonutSmallO = styled(DonutSmall)({
  color: "orange !important",
  border: "1px solid black"
});

const StyledDonutSmallG = styled(DonutSmall)({
  color: "green !important",
  border: "1px solid black"
});

const ElasticColumn = styled(Card)({
  marginLeft: "5px",
  marginRight: "5px",
  flexGrow: 1,
  flexBasis: "50%",
  padding: "1rem"
});

const StyledElasticGrid = styled(ElasticGrid)(props => ({
  justifyContent: "center",
  textAlign: "center",
  flexDirection: props.direction || "column",
  padding: props.paddingD || ""
}));

const StyledGrid = styled(Grid)({
  padding: "0.4rem",
  fontSize: "14px"
});

const StyledGridButtons = styled(Grid)({
  display: "flex",
  alignSelf: "center",
  textAlign: "end"
});

const WideColumn = styled(ElasticColumn)({
  width: "310px"
});

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const Number = styled.span(props => ({
  textAlign: "center",
  fontWeight: "bold",
  color: props.color || "black"
}));

const Text = styled.span(props => ({
  textAlign: "center",
  fontWeight: "bold",
  color: props.color || "black"
}));

const MotoRow = styled.div(props => ({
  borderBottom: "2px solid #ffffff",
  color: props.color || "black",
  backgroundColor: props.background
}));

let totalLocation = [];

function MarcaRegistradaIcon(props) {
  return (
    <SvgIcon {...props}>
      <path xmlns="http://www.w3.org/2000/svg" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12.25,13.27H10.81V16.5H9V7.71H12.26C13.29,7.71 14.09,7.94 14.66,8.4C15.22,8.87 15.5,9.5 15.5,10.36C15.5,10.96 15.37,11.46 15.11,11.86C14.85,12.26 14.46,12.58 13.93,12.81L15.83,16.4V16.5H13.89L12.25,13.27M10.81,11.81H12.27C12.72,11.81 13.07,11.69 13.32,11.46C13.57,11.23 13.69,10.91 13.69,10.5C13.69,10.09 13.58,9.77 13.34,9.53C13.11,9.29 12.75,9.18 12.26,9.18H10.81V11.81Z"/>
    </SvgIcon>
  );
}

class CurrentFleet extends React.Component {
  async fetchPermissions() {
    const response = await fetch(`${API_ROOT}/user_permission`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.token}`
      }
    });

    const objPermissions = await response.json();
    return prop("permissions", objPermissions) || {};
  }

  async fetchData(start, end) {
    const dataProvider = await dataProviderFactory("rest");

    const getLocations = dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const getItemLocations = dataProvider(GET_LIST, "item_locations", {
      filter: {
        type: "vehicle",
        endDate: moment()
          //.add(1, "month")
          .add(1, "day")
          .format("YYYYMMDD")
      },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const [locations, itemLocations] = await Promise.all([
      getLocations,
      getItemLocations
    ]);

    const response = await dataProvider(GET_LIST, "vehicles", {
      filter: {
        active: true,
        addSums: true
      },
      pagination: {
        page: 1,
        perPage: 3000
      },
      sort: { field: "vehicle_mileage", order: "ASC" }
    });

    const vehicles = map(
      v =>
        assoc(
          "location",
          this.locationForVehicle(v, locations.data, itemLocations.data),
          v
        ),
      response.data
    );

    // return vehicles;
    return filter(obj => !startsWith("Other", obj.model.model_name), vehicles);
  }

  async componentDidMount() {
    await this.updateState();
  }

  async componentDidUpdate(prevProps) {
    // Refrescar datos cuando cambie la navegación (al regresar de editar/crear vehículo)
    if (this.props.location.search !== prevProps.location.search) {
      await this.updateState();
    }
  }

  getTimeInterval = date => ({
    start: date
      .clone()
      .subtract(1, "months")
      .startOf("month"),
    end: date
      .clone()
      .add(2, "months")
      .endOf("month")
  });

  updateState = async () => {
    const permissions = await this.fetchPermissions();
    console.log(permissions);
    const data = await this.fetchData();
    this.setState({ data, permissions });
  };

  rowColor = vehicle => {
    if (vehicle.status.vehicle_status === "V" && vehicle.renting != 1) return "#aaaaaa";
    else if (startsWith("TBD", vehicle.licence_plate)) return "#9933CC";
    else return "black";
  };

  rowBackground = vehicle => {
    return path(["location", "color"], vehicle) || "white";
  };

  createLinkForEditBike = vehicle => {
    const { permissions } = this.state;
    localStorage.setItem('url_miga', JSON.stringify("/current_fleet"));
    return (
      <Link
        to={{
          pathname: `/vehicles/${vehicle.id}`,
          search: "?from=current_fleet",
          state: { miga: 'current_fleet'},
        }}
      >
           {( [1, 2, 5, 6, 9].includes(getPermissionRole()) && 
                <Edit titleAccess="Edit bike" />
          )}
      </Link>
    );
  };

  createButtonForRetireOrSalve(vehicle) {
    if (vehicle.status.vehicle_status === "A") {
      return (
        <QuickRetireButton vehicle={vehicle} callBack={this.updateState} />
      );
    } 
    else if (vehicle.status.vehicle_status === "V" && vehicle.renting == 1) {
      return (
        <Link
          to={{
            pathname: `/sale_bike/${vehicle.id}`,
            state: { miga: 'current_fleet',  renting: true},
          }}
        >
          <MarcaRegistradaIcon titleAccess="Retired bike" />
        </Link>
      );
    } 
    else {
      return (
        <Link
          to={{
            pathname: `/sale_bike/${vehicle.id}`,
            state: { miga: 'current_fleet', renting: false},
          }}
        >
          <MonetizationOn titleAccess="Sale bike" />
        </Link>
      );
    }
  }

  renderRow = vehicle => {
    const { permissions } = this.state;
    const priceTotal = JSON.parse(localStorage.getItem('url_miga'));
    console.log(priceTotal)
    const allowedToRetire = [1, 2, 5, 6, 9].includes(getPermissionRole());

    return (
      <MotoRow
        key={vehicle.id}
        background={this.rowBackground(vehicle)}
        color={this.rowColor(vehicle)}
      >
        <Grid container spacing={0} wrap="nowrap">
          
          <StyledGridButtons item xs={3}>
            {/* {allowedToRetire &&  this.createButtonForRetireOrSalve(vehicle)} */}
            {([1, 2, 5, 6, 9].includes(getPermissionRole())) && this.createButtonForRetireOrSalve(vehicle)}
            {this.createLinkForEditBike(vehicle)}
            {(startsWith(vehicle.model.model_name, "R") ||
              startsWith(vehicle.model.model_name, "K")) &&
              vehicle.totals > 11000 && (
                <InfoPopOver
                  key={`tkg_${vehicle.id}`}
                  header="Earned value"
                  text={`** ${vehicle.totals.toFixed(2)} € **`}
                  iconImage={StyledDonutSmallG}
                />
              )}

            {(startsWith(vehicle.model.model_name, "R") ||
              startsWith(vehicle.model.model_name, "K")) &&
              vehicle.totals < 6000 && (
                <InfoPopOver
                  key={`tkr_${vehicle.id}`}
                  header="Earned value"
                  text={`** ${vehicle.totals.toFixed(2)} € **`}
                  iconImage={StyledDonutSmallR}
                />
              )}

            {(startsWith(vehicle.model.model_name, "R") ||
              startsWith(vehicle.model.model_name, "K")) &&
              vehicle.totals > 6000 &&
              vehicle.totals < 11000 && (
                <InfoPopOver
                  key={`tko_${vehicle.id}`}
                  header="Earned value"
                  text={`** ${vehicle.totals.toFixed(2)} €**`}
                  iconImage={StyledDonutSmallO}
                />
              )}

            {!startsWith(vehicle.model.model_name, "R") &&
              !startsWith(vehicle.model.model_name, "K") &&
              vehicle.totals > 8000 && (
                <InfoPopOver
                  key={`tg_${vehicle.id}`}
                  header="Earned value"
                  text={`** ${vehicle.totals.toFixed(2)} € **`}
                  iconImage={StyledDonutSmallG}
                />
              )}

            {!startsWith(vehicle.model.model_name, "R") &&
              !startsWith(vehicle.model.model_name, "K") &&
              vehicle.totals < 5000 && (
                <InfoPopOver
                  key={`tr_${vehicle.id}`}
                  header="Earned value"
                  text={`** ${vehicle.totals.toFixed(2)} € **`}
                  iconImage={StyledDonutSmallR}
                />
              )}

            {!startsWith(vehicle.model.model_name, "R") &&
              !startsWith(vehicle.model.model_name, "K") &&
              vehicle.totals > 5000 &&
              vehicle.totals < 8000 && (
                <InfoPopOver
                  key={`to_${vehicle.id}`}
                  header="Earned value"
                  text={`** ${vehicle.totals.toFixed(2)} € **`}
                  iconImage={StyledDonutSmallO}
                />
              )}
          </StyledGridButtons>
          <StyledGrid item xs={9}>
            {vehicle.licence_plate}
            {vehicle.renting ? "®" : ""}/{vehicle.vehicle_color}/
            {vehicle.vehicle_mileage} km/
            {Math.round(moment().diff(vehicle.purchase_date, "days") / 30)} m
          </StyledGrid>
        </Grid>
      </MotoRow>
    );
  };

  locationForVehicle = (vehicle, locations, itemLocations) => {
    const itemLocation = find(propEq("item_id", vehicle.id), itemLocations);
    const optionalMap = when(complement(isNil));
    return optionalMap(l => find(propEq("id", l.location_id_2), locations))(
      itemLocation
    );
  };

  renderColumnHeader = (vehicles, model) => {
    const n = length(vehicles);
    const nv = length(
      filter(pathEq(["status", "vehicle_status"], "V"), vehicles)
    );
    const np = length(
      filter(propSatisfies(startsWith("TBD"), "licence_plate"), vehicles)
    );
    const locations = sortBy(
      prop("screen_order"),
      uniqBy(prop("id"), filter(identity, map(prop("location"), vehicles)))
    );
    return (
      <Header>
        <Number>{n - nv - np}</Number>
        &nbsp; (<Number color="#aaaaaa">{nv}</Number>-
        <Number color="#9933cc">{np}</Number>) &nbsp;
        {model} &nbsp; (&nbsp;
        {map(location => {
          const nTbd = length(
            filter(
              propSatisfies(startsWith("TBD"), "licence_plate"),
              filter(
                both(
                  pathEq(["location", "id"], location.id),
                  pathEq(["status", "vehicle_status"], "A")
                ),
                vehicles
              )
            )
          );
          const n =
            length(
              filter(
                both(
                  pathEq(["location", "id"], location.id),
                  pathEq(["status", "vehicle_status"], "A")
                ),
                vehicles
              )
            ) - nTbd;
          if (n === 0) {
            return undefined;
          }
          return (
            <React.Fragment key={location.id}>
              <Number color={location.header_color}>{n}</Number>
              &nbsp;
            </React.Fragment>
          );
        }, locations)}
        )
      </Header>
    );
  };

  renderColumn = (vehicles, model) => {
    const sortedVehiclesByMilage = sortWith(
      [
        ascend(path(["location", "screen_order"])),
        ascend(path(["model", "order"])),
        descend(prop("vehicle_mileage"))
      ],
      vehicles
    );
    return (
      <WideColumn key={model}>
        {this.renderColumnHeader(sortedVehiclesByMilage, model)}
        {map(this.renderRow, sortedVehiclesByMilage)}
      </WideColumn>
    );
  };

  vehiclesByModel = data => {
    const sortedData = sortWith(
      [
        ascend(path(["model", "order"])),
        ascend(path(["location", "screen_order"]))
      ],
      data
    );
    const groupedData = groupBy(vehicle => {
      const model = path(["model", "model_name"], vehicle);
      if (startsWith("Other Category", model)) return "Other";
      return model;
    }, sortedData);
    return groupedData;
  };

  renderTotals = () => {
    const sortedLocation = sortBy(prop("screen_order"), totalLocation);
    const groupedDataLocation = groupBy(item => {
      return `${item.screen_order}_${item.id}_${item.header_color}`;
    }, sortedLocation);

    const sumGrouped = mapObjIndexed(
      (value, key) => sum(map(prop("total"), value)),
      groupedDataLocation
    );

    return (
      <React.Fragment>
        (&nbsp;
        {map(key => {
          return (
            <React.Fragment key={`f_${key}`}>
              <Number key={key} color={last(key.split("_"))}>
                {prop(key, sumGrouped)}
              </Number>
              {key !== last(keys(sumGrouped)) && <span>&nbsp;-&nbsp;</span>}
            </React.Fragment>
          );
        }, keys(sumGrouped))}
        &nbsp;)
      </React.Fragment>
    );
  };

  render() {
    if (this.state === null) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }
    const { data } = this.state;
    const n = length(data);
    const nv = length(filter(pathEq(["status", "vehicle_status"], "V"), data));
    const np = length(
      filter(propSatisfies(startsWith("TBD"), "licence_plate"), data)
    );

    const locations = sortBy(
      prop("screen_order"),
      uniqBy(prop("id"), filter(identity, map(prop("location"), data)))
    );

    map(location => {
      const nTbd = length(
        filter(
          propSatisfies(startsWith("TBD"), "licence_plate"),
          filter(
            both(
              pathEq(["location", "id"], location.id),
              pathEq(["status", "vehicle_status"], "A")
            ),
            data
          )
        )
      );
      const n =
        length(
          filter(
            both(
              pathEq(["location", "id"], location.id),
              pathEq(["status", "vehicle_status"], "A")
            ),
            data
          )
        ) - nTbd;
      if (length(totalLocation) < 6) {
        totalLocation.push(Object.assign({ total: n }, location));
      }
      if (n === 0) {
        return undefined;
      }
      return (
        <React.Fragment key={location.id}>
          <Number color={location.header_color}>{n}</Number>
          &nbsp;
        </React.Fragment>
      );
    }, locations);

    const totalActive = n - nv - np;
    const totalSale = nv;
    const totalPlanned = np;
    const { permissions } = this.state;
    return (
      <Card>
        <Title title={this.props.title} />
        <CardContent>
          <ElasticGrid>
            {values(
              mapObjIndexed(this.renderColumn, this.vehiclesByModel(data))
            )}
          </ElasticGrid>
          <br />
          <StyledElasticGrid>
            <Text>{totalActive} ACTIVE VEHICLES</Text>
            <Text color="#9933cc">{totalPlanned} PLANNED VEHICLES</Text>
            <Text color="#aaaaaa">{totalSale} VEHICLES FOR SALE</Text>
          </StyledElasticGrid>
          <StyledElasticGrid direction="row">
            {this.renderTotals()}
          </StyledElasticGrid>
          <StyledElasticGrid direction="row" paddingD="20px">
          {([1, 2, 6, 9].includes(getPermissionRole())) && (
                <Link 
                to={{
                  pathname: "/vehicles/create", 
                  state: { miga: 'current_fleet'},
                }}
               /* target="_blank" */>
                Add new bike
              </Link>
   )}
           
          </StyledElasticGrid>
        </CardContent>
      </Card>
    );
  }
}

export default CurrentFleet;



// WEBPACK FOOTER //
// ./src/components/fleet.js